import { Component, EventEmitter, input, Input, OnInit, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UtilityHelper } from 'utility-lib';

// Define interfaces for our component
interface User {
  email: string;
  displayName?: string;
  id: string;
}

interface Group {
  id: string;
  name: string;
}

@Component({
  selector: 'lib-group-users',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './group-users.component.html',
  styleUrl: './group-users.component.css'
})
export class GroupUsersComponent implements OnInit {
  // Input signals
   group = input<string>();
   groupName = input<string>();
   users =  input<User[]>();
   matchedUser = input<User | null>() 

  // Output events
  @Output() removeUser = new EventEmitter<User>();
  @Output() searchUser = new EventEmitter<string>();
  @Output() saveUsers = new EventEmitter<{newUsers: User[]}>();

  // Component state
  showAddUser = signal(false);
  searchEmail = signal('');
  usersToAdd: User[] = [];

  ngOnInit(): void {
    // Initialize component state
    console.log("this.users():",this.users())
  }

  /**
   * Toggles the add user input field visibility
   */
  toggleAddUser(): void {
    this.showAddUser.update(value => !value);
    if (!this.showAddUser()) {
      this.searchEmail.set('');
    }
  }

  /**
   * Handles user search input changes
   * @param email The email being typed
   */
  onSearchChange(email: string): void {
    this.searchEmail.set(email);
    this.searchUser.emit(email);
  }

  /**
   * Adds a matched user to the pending list
   */
  addMatchedUser(): void {
    if (this.matchedUser() && !this.userExists(this.matchedUser()!.email)) {
      console.log('Adding user:', this.matchedUser());
      this.usersToAdd.push(this.matchedUser()!);
      this.searchEmail.set('');
      this.toggleAddUser();
    }
  }

  /**
   * Emits event to remove a user from the group
   * @param email The email of the user to remove
   */
  onRemoveUser(user: User): void {
    this.removeUser.emit(user);
  }

  /**
   * Removes a user from the pending add list
   * @param email The email to remove
   */
  removeFromAddList(email: string): void {
    this.usersToAdd = this.usersToAdd.filter(user => user.email !== email);
  }

  /**
   * Saves all pending user additions
   */
  onSaveUsers(): void {
    if (this.usersToAdd.length > 0) {
      const newUsers = this.usersToAdd.map(user => {
        return {
          email: user.email,
          displayName: user.displayName || '',
          id: user.id
        };
      })
      this.usersToAdd = [];
      this.saveUsers.emit({ newUsers });

    }
  }

  /**
   * Checks if a user already exists in the group or pending list
   * @param email The email to check
   * @returns Boolean indicating if user exists
   */
  private userExists(email: string): boolean {
    return this.users()?.some(u => u.email === email) || 
           this.usersToAdd.some(u => u.email === email);
  }

  toCapitilize(str: string): string {
    return UtilityHelper.capitalizeFirstLetter(str);
  }
}
